/**
 * Height of the retirement banner above the header. It wraps to two lines on narrow screens
 * (CLI-569), so it is measured and published instead of being a fixed 40px.
 */
export const BANNER_HEIGHT_CSS_VAR = '--app-banner-h';
export const BANNER_HEIGHT_CHANGE_EVENT = 'app-banner-height-change';
const ONE_LINE_BANNER_HEIGHT = 40;

let bannerHeight = window.config.enableDeprecationBanner ? ONE_LINE_BANNER_HEIGHT : 0;

export const getBannerHeight = (): number => bannerHeight;

export const setBannerHeight = (heightPx: number): void => {
  document.documentElement.style.setProperty(BANNER_HEIGHT_CSS_VAR, `${heightPx}px`);
  if (heightPx === bannerHeight) {
    return;
  }
  bannerHeight = heightPx;
  window.dispatchEvent(new Event(BANNER_HEIGHT_CHANGE_EVENT));
};

export const onBannerHeightChange = (listener: () => void): (() => void) => {
  window.addEventListener(BANNER_HEIGHT_CHANGE_EVENT, listener);
  return () => window.removeEventListener(BANNER_HEIGHT_CHANGE_EVENT, listener);
};

export const watchBannerHeight = (banner: HTMLElement): (() => void) => {
  const measure = () => setBannerHeight(banner.offsetHeight);
  measure();

  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }

  const observer = new ResizeObserver(measure);
  observer.observe(banner);
  return () => observer.disconnect();
};
